<script lang="ts" setup>
import LoadingSpinner from './LoadingSpinner.vue';

interface Props {
  message?: string;
  hint?: string;
}

defineProps<Props>();
</script>

<template>
  <div class="flex size-full min-h-[500px] grow items-center justify-center">
    <div class="flex flex-col items-center justify-center gap-5">
      <LoadingSpinner />
      <div class="flex flex-col items-center justify-center gap-1">
        <span v-if="message" class="text-sm font-medium text-brand-primary-dark">{{
          message
        }}</span>
        <span v-if="hint" class="text-xs text-semantic-text-secondary">{{ hint }}</span>
      </div>
    </div>
  </div>
</template>
